import React, { useEffect, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { OuterExamTimer } from '@edx/frontend-lib-special-exams';
import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient as getHttpClient } from '@edx/frontend-platform/auth';

import TabPage from './TabPage';

const isArray = item => {
	return Array.isArray(item);
};
const isObject = item => {
	return item === Object(item) && !isArray(item) && typeof item !== 'function';
};
const toCamel = string => {
	return string.replace(/([-_][a-z])/ig, ($1) => {
		return $1.toUpperCase()
			.replace('-', '')
			.replace('_', '');
	});
};
function keysTo(data, func = toCamel) {
	if (isObject(data)) {
		const object = {};
		Object.keys(data)
			.forEach((item) => {
				object[func(item)] = keysTo(data[item], func);
			});
		return object;
	} else if (isArray(data)) {
		return data.map((item) => {
			return keysTo(item, func);
		});
	}
	return data;
}

export default function TabContainer(props) {
  const {
    children,
    fetch,
    slice,
    tab,
  } = props;

  const { courseId: courseIdFromUrl } = useParams();
  const dispatch = useDispatch();

  //  TODO: remove - get it directly from fronted-component-header
  const [userAccount, setUserAccount] = useState({})

  // TODO: split data from this endpoint to get data e.q. resumeBlock, userManualLmsLink, sso directly in fronted-component-header
  useEffect(() => {
    const selector = document.querySelector('.authentication-bar span.username')

    if(selector) {
      const username = selector.textContent

      const fetchAccount = async () => {
        const { data } = await getHttpClient().get(`${getConfig().LMS_BASE_URL}/api/user/v1/accounts/${username}`);
        setUserAccount(keysTo(data))
      }
      username && fetchAccount();
    }
  }, [])

  useEffect(() => {
    // The courseId from the URL is the course we WANT to load.
    dispatch(fetch(courseIdFromUrl));
  }, [courseIdFromUrl]);

  // The courseId from the store is the course we HAVE loaded.  If the URL changes,
  // we don't want the application to adjust to it until it has actually loaded the new data.
  const { courseId, courseStatus } = useSelector(state => state[slice]);

  return (
    <TabPage
      activeTabSlug={tab}
      courseId={courseId}
      courseStatus={courseStatus}
      metadataModel={`${slice}Meta`}
      userAccount={userAccount}
    >
      {courseId && <OuterExamTimer courseId={courseId} />}
      {children}
    </TabPage>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  fetch: PropTypes.func.isRequired,
  slice: PropTypes.string.isRequired,
  tab: PropTypes.string.isRequired,
};
